import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { ComponentTitle, ComponentBody } from "./Common";
import { AddCommaNumber } from "../../../helpers/Utils";
import IntlMessages from "../../../helpers/IntlMessages";

export default (props) => {
  const [state, setState] = useState({
    columns: [],
  });

  useEffect(() => {
    setState({
      ...state,
      columns: [
        {
          Header: <div style={{ textAlign: "center" }}>{props.title}</div>,
          columns: [
            {
              Header: <IntlMessages id="analytics.table.stt" />,
              accessor: "stt",
              maxWidth: 50,
            },
            {
              Header: <IntlMessages id="analytics.table.method" />,
              accessor: "label",
              minWidth: 120,
            },
            {
              Header: (
                <ComponentTitle
                  compare={props.setting.compare}
                  title={<IntlMessages id="analytics.table.order_count" />}
                  value={props.total_count}
                  align="center"
                />
              ),
              accessor: "count",
              Cell: (_props) => {
                const value = _props.value + " đơn";
                return (
                  <ComponentBody
                    compare={props.setting.compare}
                    all={props.setting.all}
                    type="text"
                    align="center"
                    value={value}
                    compare_value={_props.original.compare_count}
                  />
                );
              },
            },
            {
              Header: (
                <ComponentTitle
                  compare={props.setting.compare}
                  title={<IntlMessages id="analytics.table.product_count" />}
                  value={props.total_product_count}
                  align="center"
                />
              ),
              accessor: "product_count",
              Cell: (_props) => {
                const value = AddCommaNumber(_props.value);
                return (
                  <ComponentBody
                    compare={props.setting.compare}
                    all={props.setting.all}
                    type="text"
                    align="center"
                    value={value}
                    compare_value={_props.original.compare_product_count}
                  />
                );
              },
            },
            {
              Header: (
                <ComponentTitle
                  compare={props.setting.compare}
                  title={<IntlMessages id="analytics.table.total_amount" />}
                  value={AddCommaNumber(props.total_price)}
                  align="end"
                />
              ),
              minWidth: 140,
              accessor: "price",
              sortMethod: (a, b) => Number(a) - Number(b),
              Cell: (_props) => (
                <ComponentBody
                  compare={props.setting.compare}
                  all={props.setting.all}
                  type="price"
                  align="end"
                  value={_props.value}
                  compare_value={_props.original.compare_price}
                />
              ),
            },
          ],
        },
      ],
    });
  }, [props.data, props.setting.compare, props.setting.all]);

  return (
    <ReactTable
      defaultPageSize={4}
      data={props.data}
      columns={state.columns}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={false}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
};
